<script setup lang="ts">
import { computed } from 'vue'
import ContentView from '@/core/components/ContentView.vue'
import { useCommonStore } from '@/modules/simakatra/stores/common'
import HeaderTitle from '@/modules/simakatra/components/HeaderTitle.vue'
import SamudkoyContent from '@/modules/simakatra/components/SamudkoyContent.vue'
import OverviewContent from '@/modules/simakatra/components/OverviewContent.vue'

const commonStore = useCommonStore()

const currentContent = computed(() => commonStore.mainContent)
</script>

<template>
  <main class="main">
    <HeaderTitle />
    <ContentView :content="currentContent">
      <template #samudkoy><SamudkoyContent /></template>
      <template #overview><OverviewContent /></template>
    </ContentView>
  </main>
</template>

<style scoped>
.main {
  height: 100%;
}
</style>
